import React from 'react'
import { Button } from '../Button/Button';
import "./IndustryTwoButtonsSection.scss";
import content from "./content";
import { useLanguageCtx } from '../../../store/providers/LanguageContext';

const IndustryTwoButtonsSection = ({bgColor, pb, extraTopPadding}) => {
	const {language} = useLanguageCtx();

  return (
		<div
			style={{ backgroundColor: bgColor }}
			className={`${
				!extraTopPadding ? "top-space-section padding" : "pt-200"
			} ${pb && "pb-80"}`}
		>
			<div className="flex space-around wrap industryTwoButtonsSection--container">
				<Button type="button light-blue" content={content[language].button_1} />
				<Button
					type="button light-blue outline"
					content={content[language].button_2}
				/>
			</div>
		</div>
	);
}

export default IndustryTwoButtonsSection
